module.exports = __webpack_public_path__ + "static/media/floorballgoal.a1103ea4.jpg";